import { render } from "./contact.vue?vue&type=template&id=7f895bd4&scoped=true&ts=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"

import "./contact.vue?vue&type=style&index=0&id=7f895bd4&scoped=true&lang=less"

import exportComponent from "/root/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f895bd4"]])

export default __exports__